<!-- Modals -->
<app-common-bulk-select-benefits-employee-dialog
    #selectEmployees
    headerText="benefits.assignEmployees"
    [hasEnhancedManagedBenefits]="benefitPlan.hasEnhancedManagedBenefits"
    bannerContent="benefits.benefitsPayroll.employeesCanOnlyBeAssignedToOnePlan"
    bannerType="info"
    [alwaysDisplayBanner]="!benefitPlan.hasEnhancedManagedBenefits"
></app-common-bulk-select-benefits-employee-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-form-benefits-enrollment-settings
                    [benefitPlan]="benefitPlan"
                    #BenefitsEnrollmentSettings
                ></app-form-benefits-enrollment-settings>

                <h3 *ngIf="traditionalBenefits">Employees selected for enrollment</h3>

                <h3
                    *ngIf="
                        traditionalBenefits &&
                        ((benefitPlan.employees && benefitPlan.employees.length > 0) ||
                            (selectEmployees && selectEmployees.selection))
                    "
                >
                    {{
                        selectEmployees && selectEmployees.selection
                            ? selectEmployees.selection.length
                            : activeEmployeesOnBenefitPlan().length
                    }}
                    employees are assigned to this plan
                </h3>

                <p
                    *ngIf="benefitPlan?.hasEnhancedManagedBenefits"
                    class="columns-3 text-align-left"
                    [innerHTML]="
                        'benefits.moveEmployeeToAnotherPlanNote'
                            | translate: { benefitsManagerEmail: 'benefits@humi.ca' }
                    "
                ></p>

                <ui-button type="link" (click)="onAssign()" type="primary">
                    {{
                        (benefitPlan.employees && benefitPlan.employees.length > 0) ||
                        (selectEmployees && selectEmployees.selection)
                            ? 'Edit Selection'
                            : 'Select employees'
                    }}</ui-button
                >
            </div>

            <div class="flex justify-flex-end">
                <ui-button type="ghost" (click)="onCancel()">Cancel</ui-button>
                <ui-button type="primary" (click)="onAddToPlan()">Add To Plan</ui-button>
            </div>
        </div>

        <!-- In following iteration sidebar to be displayed conditionally if benefit policy has integration_enabled -->
        <div class="sidebar" *ngIf="false">
            <div class="ui segment">
                <h3>Adding Employees</h3>
                <p>
                    Once employees have been added to a division in plan, completing enrollment will send out enrollment
                    forms for the selected employees to complete.
                </p>
                <p>
                    <a href="https://humi.zendesk.com/hc/en-us/articles/360049374073" target="_blank">Learn more</a>
                    about training programs.
                </p>
            </div>
        </div>
    </div>
</div>
